export default __webpack_public_path__ + "static/happyplace@2x-56fdce40196cbe33b6e6c289906e4a3c.webp";